/* Floopilo Holiday PDP pricing display. Checkout remains the discount authority. */
(() => {
  'use strict';
  if (window.FloopiloPdpHolidayPriceReady) return;
  window.FloopiloPdpHolidayPriceReady = true;
  function money(cents, format, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'USD'
      }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }
  function init(root) {
    if (root.dataset.holidayPriceReady) return;
    root.dataset.holidayPriceReady = 'true';
    const original = root.querySelector('[data-pdp-offer-original]');
    const current = root.querySelector('[data-pdp-offer-current]');
    const context = root.closest('[data-floopilo-v2-product-form], [data-thanksgiving-pdp]');
    if (!original || !current) return;
    function update(amount) {
      const value = Number(amount);
      if (!Number.isFinite(value) || value <= 0) return;
      const base = Math.round(value);
      const sale = base - Math.floor((base * 20) / 100);
      root.dataset.priceCents = String(base);
      original.textContent = money(base, root.dataset.moneyFormat, root.dataset.currency);
      current.textContent = money(sale, root.dataset.moneyFormat, root.dataset.currency);
    }
    update(root.dataset.priceCents);
    if (context) context.addEventListener('floopilo:offer-price', event => {
      if (event.detail && event.detail.priceCents != null) update(event.detail.priceCents);
    });
  }
  const mount = () => document.querySelectorAll('[data-floopilo-pdp-offer]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();